var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57895 0C2.62975 0 1.71943 0.377066 1.04825 1.04825C0.377067 1.71943 0 2.62975 0 3.57895L0 26.8421C0 27.7913 0.377067 28.7016 1.04825 29.3728C1.71943 30.044 2.62975 30.4211 3.57895 30.4211H4.62758L3.73284 31.3158L6.26316 33.8461L9.68821 30.4211H14.3158V16.1053H3.57895V3.57895H23.2632V7.15789H26.8421V3.57895C26.8421 2.62975 26.465 1.71943 25.7939 1.04825C25.1227 0.377066 24.2124 0 23.2632 0H3.57895ZM5.36842 21.4737H8.95453V25.0598H5.36842V21.4737Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7904 8.94727H20.2622L16.1052 19.3387V33.1052H19.6842V30.4209H39.3684V33.1052H42.9473V19.3387L38.7904 8.94727ZM37.799 16.1052H21.2535L22.6851 12.5262H36.3674L37.799 16.1052ZM21.4736 21.4736H25.0598V25.0597H21.4736V21.4736ZM37.5861 21.4736V25.0597H34V21.4736H37.5861Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.1ffcb79ea9fc4c726e9a63ad90e6060e.svg";
export { ForwardRef as ReactComponent };